import { TeamPlayersNumber } from 'shared/types/team-players-number';
import { SymbolicTeamFormation } from '../types';

export const getDefaultFormation = (playersNumber: TeamPlayersNumber): SymbolicTeamFormation => {
  switch (playersNumber) {
    case TeamPlayersNumber.FIVE:
      return SymbolicTeamFormation.ONE_TWO_TWO;
    case TeamPlayersNumber.SIX:
      return SymbolicTeamFormation.ONE_THREE_TWO;
    case TeamPlayersNumber.SEVEN:
      return SymbolicTeamFormation.ONE_THREE_THREE;
    case TeamPlayersNumber.EIGHT:
      return SymbolicTeamFormation.ONE_THREE_TWO_TWO;
    case TeamPlayersNumber.NINE:
      return SymbolicTeamFormation.ONE_TWO_FOUR_TWO;
    case TeamPlayersNumber.TEN:
      return SymbolicTeamFormation.ONE_THREE_THREE_THREE;
    case TeamPlayersNumber.ELEVEN:
      return SymbolicTeamFormation.ONE_FOUR_FOUR_TWO;
  }
}
